import { Link } from "react-router-dom";

function FounderInner() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>{" "}
          <li className="breadcrumb-item active"> Leadership</li>
          <li className="breadcrumb-item active">Our Founder </li>
        </ul>
      </div>
      <div className="innersec container my-5 founder_message">
        <div className="row">
          <div class="col-lg-12">
            <h1> Our Founder </h1>
          </div>
          <div className="col-lg-12">
            <>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/dummy1.png"
                className="col-md-4 float-md-end left-img img-fluid"
                alt=""
              />
              <p>
                Mr. FRANK ANTHONY had a versatile career. A University Prizeman
                and Scholar, Viceroy's Gold Medalist in English, Mr. Frank
                Anthony received his higher education at the Nagpur University
                and the Inner Temple, London. He was a legal luminary, Senior
                Advocate, and a leading criminal law practitioner. Counted among
                the prominent framers of the Constitution, Mr. Anthony occupied
                the position of an eminent jurist and lawyer practicing in the
                Supreme Court and the Delhi High Court.
                <br />
                <br />
                He was a member of the Central Legislature since 1942 and a
                Member of Parliament (Lok Sabha) for almost five decades. He was
                acclaimed as one of India's most outstanding Parliamentarians.
                In 1946, Mr. Anthony was one of India's principal delegates, in
                the first delegation sent by Independent India to the United
                Nations. In 1948 and 1957 he was one of India's representatives
                to the Commonwealth Parliamentary Conference.
                <br />
                <br />
                Mr. Anthony was a member of the National Defence Council during
                World War II and a member of India's National Defence Council of
                Independent India. He was a member of the National Integration
                Council set up by Jawaharlal Nehru, the then Prime Minister in
                1961. Among his many offices, Mr. Anthony was the elected
                Chairman, since 1947, of the Inter-State Board of Anglo-Indian
                Education and held office till his demise on 2nd December, 1993.
                He was the elected Chairman, since its inception in 1958, of the
                Council for the Indian School Certificate Examinations, a
                premier Examination Board in India, and held office till his
                demise on 2nd December, 1993. He was founder Chairman of the
                All-India Anglo-Indian Education Institution, a registered
                society, which today, owns and administers 4 (four) leading
                schools named after him in Delhi, Kolkata and Bangalore.
                <br />
                <br />
                Because of his continuing public work and leadership of the
                Anglo- Indian Community, Mr. Anthony felt obliged to decline the
                offer by the Prime Minister, Mrs. Indira Gandhi made in 1967, of
                the Governorship of Punjab.
              </p>
              <br />
              <div className="mesdeskimg">
                <h3> Frank Anthony Esq., </h3>
                <h5>Founder</h5>
                <h5>25th September, 1908 – 2nd December, 1993 </h5>
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
}
export default FounderInner;
